import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import ButtonComponent from './ButtonComponent.vue'

export default Node.create({
  name: 'customButton',

  addOptions() {
    return {
      HTMLAttributes: {
        class: 'custom-button',
      },
    }
  },

  group: 'inline',

  inline: true,

  selectable: true,

  atom: true,

  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML: element => element.getAttribute('href'),
        renderHTML: attributes => {
          return {
            href: attributes.href,
          }
        },
      },
      label: {
        default: 'Click me',
        parseHTML: element => element.getAttribute('label'),
        renderHTML: attributes => {
          return {
            label: attributes.label,
          }
        },
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'button-component',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['button-component', HTMLAttributes]
  },

  addNodeView() {
    return VueNodeViewRenderer(ButtonComponent)
  },
}) 